import { AlertBox } from '@iwoca/orion';
import { AlertBoxProps } from '@iwoca/orion/lib/components/AlertBox/AlertBox';
import classNames from 'classnames';

import styles from '../TopUpStatusAlertBox.module.css';

export const TopUpStatusAlertBox = ({
    variant,
    className,
    icon,
    description,
    cta
}: {
    variant: AlertBoxProps['variant'];
    className?: string;
    icon: React.ReactNode;
    description: React.ReactNode;
    cta?: React.ReactNode;
}) => {
    return (
        <AlertBox
            data-testid="topup-status-alert-box"
            variant={variant}
            className={classNames(styles.alertBox, className)}
        >
            {icon}
            <div className={styles.descriptionContainer}>
                <p className={styles.description}>{description}</p>
                {cta}
            </div>
        </AlertBox>
    );
};
